import type { ReactNode } from 'react'

interface MetricCardProps {
  label: string
  value: number | string
  hint?: string
  delta?: { value: number; suffix?: string } | null
  icon?: ReactNode
  accent?: 'default' | 'blueprint' | 'amber' | 'red'
}

const ACCENTS: Record<NonNullable<MetricCardProps['accent']>, string> = {
  default: 'text-ink-900',
  blueprint: 'text-blueprint-700',
  amber: 'text-amber-700',
  red: 'text-red-700',
}

export function MetricCard({
  label,
  value,
  hint,
  delta,
  icon,
  accent = 'default',
}: MetricCardProps) {
  const deltaSign = delta && delta.value !== 0 ? (delta.value > 0 ? '+' : '') : ''
  const deltaColor = !delta
    ? ''
    : delta.value > 0
      ? 'text-emerald-700'
      : delta.value < 0
        ? 'text-red-700'
        : 'text-ink-700/60'
  return (
    <div className="bp-card p-3 flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <span className="text-xs font-mono uppercase tracking-wider text-ink-700/60">
          {label}
        </span>
        {icon && <span className="text-ink-700/40">{icon}</span>}
      </div>
      <div className={`text-2xl font-medium tracking-tight ${ACCENTS[accent]}`}>{value}</div>
      <div className="flex items-center gap-2 text-[11px] font-mono text-ink-700/60">
        {hint && <span>{hint}</span>}
        {delta && (
          <span className={deltaColor}>
            {deltaSign}
            {delta.value}
            {delta.suffix ?? ''}
          </span>
        )}
      </div>
    </div>
  )
}
